module.exports = __webpack_public_path__ + "static/media/ic-nav-taxation-inactive.4b7ef688.svg";